import type { ApiCommunications, NullPromise } from '../../webmodule-common/interop/webmodule-interop';
import type {
  InputCreateFranchiseeClient,
  InputCreateTermsAndConditions,
  InputUpdateTermsAndConditions,
  RequestBrowseTermsAndConditionsSummary,
  RequestGetClientDefaultTermsAndConditions,
  RequestGetClientDefaultTermsAndConditionsById,
  RequestGetClientDefaultTermsAndConditionsListByIds,
  RequestGetDefaultTermsAndConditions,
  RequestGetFranchiseeClientListByIds,
  RequestGetTermsAndConditions,
  ResultBrowseTermsAndConditionsSummary,
  ResultCreateFranchiseeClient,
  ResultCreateTermsAndConditions,
  ResultGetClientDefaultTermsAndConditions,
  ResultGetClientDefaultTermsAndConditionsById,
  ResultGetClientDefaultTermsAndConditionsListByIds,
  ResultGetFranchiseeClientListByIds,
  ResultGetTermsAndConditions,
  ResultUpdateTermsAndConditions
} from './dealer-api-interface-franchisee';
import type { TermsAndConditionsApi } from './terms-and-conditions-api';

export class TermsAndConditionsApiImplementation implements TermsAndConditionsApi {
  private readonly api: ApiCommunications;
  private readonly baseRoute = 'api/Franchisee/';

  constructor(api: ApiCommunications) {
    this.api = api;
  }

  async getDefaultTermsAndConditions(
    body: RequestGetDefaultTermsAndConditions
  ): NullPromise<ResultGetTermsAndConditions> {
    return this.post<ResultGetTermsAndConditions>('GetDefaultTermsAndConditions', body);
  }

  private post<T>(endpoint: string, body: unknown): NullPromise<T> {
    return this.api.post<T>(`${this.baseRoute}${endpoint}`, body);
  }

  async browseTermsAndConditionsSummary(
    body: RequestBrowseTermsAndConditionsSummary
  ): NullPromise<ResultBrowseTermsAndConditionsSummary> {
    return this.post<ResultBrowseTermsAndConditionsSummary>('BrowseTermsAndConditionsSummary', body);
  }

  async createFranchiseeClient(body: InputCreateFranchiseeClient): NullPromise<ResultCreateFranchiseeClient> {
    return this.post<ResultCreateFranchiseeClient>('CreateFranchiseeClient', body);
  }

  async createTermsAndConditions(body: InputCreateTermsAndConditions): NullPromise<ResultCreateTermsAndConditions> {
    return this.post<ResultCreateTermsAndConditions>('CreateTermsAndConditions', body);
  }

  async getClientDefaultTermsAndConditionsById(
    body: RequestGetClientDefaultTermsAndConditionsById
  ): NullPromise<ResultGetClientDefaultTermsAndConditionsById> {
    return this.post<ResultGetClientDefaultTermsAndConditionsById>('GetClientDefaultTermsAndConditionsById', body);
  }

  async getClientDefaultTermsAndConditionsListByIds(
    body: RequestGetClientDefaultTermsAndConditionsListByIds
  ): NullPromise<ResultGetClientDefaultTermsAndConditionsListByIds> {
    return this.post<ResultGetClientDefaultTermsAndConditionsListByIds>(
      'GetClientDefaultTermsAndConditionsListByIds',
      body
    );
  }

  async getClientsDefaultTermsAndConditions(
    body: RequestGetClientDefaultTermsAndConditions
  ): NullPromise<ResultGetClientDefaultTermsAndConditions> {
    return this.post<ResultGetClientDefaultTermsAndConditions>('GetClientsDefaultTermsAndConditions', body);
  }

  async getFranchiseeClientListByIds(
    body: RequestGetFranchiseeClientListByIds
  ): NullPromise<ResultGetFranchiseeClientListByIds> {
    return this.post<ResultGetFranchiseeClientListByIds>('GetFranchiseeClientListByIds', body);
  }

  async getTermsAndConditions(body: RequestGetTermsAndConditions): NullPromise<ResultGetTermsAndConditions> {
    return this.post<ResultGetTermsAndConditions>('GetTermsAndConditions', body);
  }

  async updateTermsAndConditions(body: InputUpdateTermsAndConditions): NullPromise<ResultUpdateTermsAndConditions> {
    return this.post<ResultUpdateTermsAndConditions>('UpdateTermsAndConditions', body);
  }
}
